import React from 'react'
import { Link } from "react-router-dom";
import { withRouter } from 'react-router';
import './index.css';
import P from "prop-types";
const backImg = require('../../../../common/images/arrow_l.png')

@withRouter
export default class Index extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };

    constructor(props) {
        super(props);
    }

  render() {
    return (
      <div className='commonHeader clearfix'>
          <span onClick={this.back} style={{color:'#333'}}><img style={{width:'0.14rem',margin:"0px 0.14rem"}} src={backImg} alt=""/>返回</span>
      </div>
    )
  }

  back = ()=>{
          let backUrlArray = ['/packet','/feedback','/wuliulist','/rotaryList']
      if(backUrlArray.some(i=>i===this.props.location.pathname)){
          this.props.history.goBack();
          return
      }

      this.props.history.push('/')
  }
}